<template>
  <main class="container">
    <div class="page-wrapper">
      <h1 class="page-title" data-testid="page-title">Congratulations!</h1>

      <p>
        All your housemates have now joined Split The Bills so we can get
        started on setting up your utilities. You’ll receive a confirmation
        email shortly, but for now you can sit back, relax and forget about
        bills!
      </p>

      <hr />

      <h1>What Happens Next?</h1>

      <check-list :items="whatsNextItems" />

      <hr />

      <a class="btn btn--big homepage-btn" href="https://splitthebills.co.uk">
        Back To Homepage
      </a>
    </div>
    <p class="cancel-disclaimer">
      You will receive an email within 3 business days confirming your Direct
      Debit mandate has been set up.
    </p>
  </main>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import CheckList from "@/components/CheckList";

export default {
  name: "HouseComplete",
  data() {
    return {
      whatsNextItems: [
        "You can put your feet up, we’ve got everything in hand",
        "We’ll start setting up your utilities",
        "You won’t pay a thing until your start date",
      ],
    };
  },
  methods: {
    ...mapActions(["clearSession"]),
    ...mapMutations({
      hideBackBtn: "HIDE_BACK_BTN",
    }),
  },
  created() {
    // We've finished the signup so reset the store data
    this.clearSession();
    // We don't need back button on this page.
    this.hideBackBtn();

    this.trackGoogleEvent(
      "Final housemate completes",
      "Joining Housemate",
      "Final housemate completes",
    );
    this.trackFacebookEvent("Final housemate completes");
  },
  components: {
    CheckList,
  },
};
</script>

<style lang="scss" scoped>
main {
  text-align: center;
}

p {
  font-size: 18px;
}

hr {
  @include media(">=medium") {
    width: 90%;
  }
}

.homepage-btn {
  margin-bottom: 0;
}

.cancel-disclaimer {
  font-size: 14px;
  margin: 2rem 6rem;

  @include media("<medium") {
    margin: 2rem 0;
  }
}
</style>
